<template>
  <div class="info">
    <div class="info__title" :style="{color: $store.registratorCaptionColor}">
      {{ element.kiosk_title[$store.activeLanguage] }}
    </div>
    <input
      class="info__input"
      type="text"
      :placeholder="isPhoneNumber"
      :class="{ 'info__input_focused': isActive }"
      :value="value"
      :style="{color: $store.registratorCaptionColor}"
      readonly
      @click="onClickInput"
      @keydown="preventInput"
      @keyup="preventInput"
      @keypress="preventInput"
      @input="preventInput"
      @paste="preventInput"
      @cut="preventInput"
      @mousedown="preventInput"
      @focus="preventInput"
    />
  </div>
</template>

<script>
import parsePhoneNumberFromString from 'libphonenumber-js'

export default {
  name: 'GroupParamElement',
  props: {
    element: {type: Object, required: true},
    isActive: {type: Boolean, required: false},
  },
  computed: {
    isPhoneNumber() {
      return this.element.type === 'phone';
    },
    value() {
      if (!this.isPhoneNumber) return this.element.data;

      const parsedPhoneNumber = parsePhoneNumberFromString(this.element.data)
      return parsedPhoneNumber ? parsedPhoneNumber.formatInternational() : this.element.data
    }
  },
  mounted() {
    if (this.isPhoneNumber) {
      this.element.data = '+';
    }
  },
  methods: {
    changeCaretPosition(event) {
      event.preventDefault();
      event.target.selectionStart = event.target.value.length
    },
    onClickInput(event) {
      this.changeCaretPosition(event);
      this.$emit('focus', event);
    },
    preventInput(event) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  },
};
</script>

<style lang="scss" scoped>
.info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-width: 615px;
  margin-bottom: 25px;

  &__title {
    margin-bottom: 10px;
    margin-left: 10px;
    font-size: 26px;
  }

  &__input {
    display: inline-block;
    box-sizing: border-box;
    padding: 9px 24px;
    font-size: 32px;
    background: rgba(239, 239, 244, 0.3);
    border-radius: 180px;
    height: auto;
    border: none;
    caret-color: transparent;
    cursor: default;
    user-select: none;

    &_focused {
      background: rgba(239, 239, 244, 0.45);
      box-shadow: 0 33px 38px rgba(0, 0, 0, 0.0314074), 0 12px 12px rgba(0, 0, 0, 0.05), 0 3px 3px rgba(0, 0, 0, 0.08);
      text-shadow: 0 3px 3px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
